import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminRoleIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AdminRoleEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminRole-001";

        let QBE = {
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "AdminRole": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.AdminRole.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_roles",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminRoleIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminRole = {};

        adminRole["USID"] = this.getAttributeValue("USID");
        adminRole["Name"] = this.getAttributeValue("Name");
        adminRole["ParentRoleUSID"] = this.getAttributeValue("ParentRoleUSID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminRole-001";
        payload.ShifamedMessage.AdminRole = adminRole;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/admin_roles",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminRole-001",
                "idoc-response": "v1.AdminRole-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminRoleIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

        enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminRole-001";
        payload.ShifamedMessage.AdminRole = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_roles",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminRole-001",
                "idoc-response": "v1.AdminRole-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1AdminRoleIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminRole-001";
        payload.ShifamedMessage.AdminRole = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_roles",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminRole-003",
                "idoc-response": "v1.AdminRole-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AdminRoleEnterpriseComponent;